__turbopack_context__.v({
  "copyControl": "ImprintPage-module__uwUeQW__copyControl",
  "page": "ImprintPage-module__uwUeQW__page",
  "row": "ImprintPage-module__uwUeQW__row",
  "section": "ImprintPage-module__uwUeQW__section",
  "term": "ImprintPage-module__uwUeQW__term",
  "value": "ImprintPage-module__uwUeQW__value",
  "valueText": "ImprintPage-module__uwUeQW__valueText",
});
